var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('b-container',[_c('b-img',{attrs:{"id":_vm.thumbnailID,"rounded":"","fluid":"","src":_vm.signedUrl,"alt":"Thumbnail image"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }